import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './household-composition.reducer';

export const HouseholdCompositionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const householdCompositionEntity = useAppSelector(state => state.householdComposition.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="householdCompositionDetailsHeading">
          <Translate contentKey="apiLocationApp.householdComposition.detail.title">HouseholdComposition</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.householdComposition.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.householdComposition.date">Date</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.householdComposition.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.householdComposition.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.householdComposition.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="onePersonHousehold">
              <Translate contentKey="apiLocationApp.householdComposition.onePersonHousehold">One Person Household</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.onePersonHousehold}</dd>
          <dt>
            <span id="singleFamilyHousehold">
              <Translate contentKey="apiLocationApp.householdComposition.singleFamilyHousehold">Single Family Household</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.singleFamilyHousehold}</dd>
          <dt>
            <span id="otherHouseholdTypes">
              <Translate contentKey="apiLocationApp.householdComposition.otherHouseholdTypes">Other Household Types</Translate>
            </span>
          </dt>
          <dd>{householdCompositionEntity.otherHouseholdTypes}</dd>
        </dl>
        <Button tag={Link} to="/household-composition" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/household-composition/${householdCompositionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HouseholdCompositionDetail;
